import { PreRegistrationPatientInfoEntity } from "@/domain/entity/pre-regitration-patient-info-entity";
import { PreRegistrationRepository } from "@/domain/repository/pre-registration-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class GetPreRegistrationListUsecase {
  //MARK: Constructor
  constructor(private readonly preRegistrationRepo: PreRegistrationRepository) {}

  //MARK: execute
  async execute(): Promise<SATResult<PreRegistrationPatientInfoEntity[], SATError>> {
    const result = await this.preRegistrationRepo.getPreRegistrationList();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(result.value);
  }
}
